import { render } from "./explore.vue?vue&type=template&id=c7a6713c"
const script = {}
script.render = render

export default script